import React, { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import SearchField from "../../../../../../../../../../customComponent/searchField/searchField";
import { Chip } from "@mui/material";

const CategoryTable = ({ categoryList, onEdit, onDelete }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };


  const filteredCategoryList = categoryList.filter((category) => {
    return (
      category.category_name.toLowerCase().includes(searchValue.toLowerCase()) ||
      (searchValue.toLowerCase() === "yes" && category.is_home_listed === true) ||
      (searchValue.toLowerCase() === "no" && category.is_home_listed === false)
    );
  });

  
  
  const displayCategory = searchValue ? filteredCategoryList : categoryList;
  const categoriesWithIndex = displayCategory.map((category, index) => ({
    ...category,
    displayIndex: index + 1,
  }));
  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "category ID", width: 120 },
    {
      field: "icon",
      headerName: "Icon",
      width: 100,
      renderCell: (params) => (
        <img
          src={`${params.value}`}
          alt={params.row.category_name}
          width={30}
        />
      ),
    },
    { field: "category_name", headerName: "Category Name", width: 200 },
    {
      field: "is_home_listed",
      headerName: "Is Home Listed",
      width: 150,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "is_approved",
      headerName: "Approval Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Approved" : "Pending"}
          color={params.value ? "success" : "warning"}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="action-btn">
          <Button
            variant="outlined"
            color="primary"
            style={{ marginRight: "5px" }}
            onClick={() => onEdit(params.row)}
          >
            <EditIcon />
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => onDelete(params.row)}
          >
            <DeleteIcon />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <SearchField
        searchValue={searchValue}
        handleSearchChange={handleSearchChange}
      />
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm:682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={categoriesWithIndex}
          columns={columns}
          disableSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default CategoryTable;
